exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* UI Primary Colors */\n/* #FF661A */\n/* UI Secondary Colors */\n/* 3.0 colors */\n/* Using www naming convention for now, should be consistent with gui */\n/* #4F36D6 Sounds Primary */\n/* modals */\n/* Overlay UI Gray Colors */\n/* Typography Colors */\n/* Down Deep */\n.modal-title {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  text-align: center;\n  color: white;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 1rem;\n  font-weight: bold; }\n", ""]);

// exports
